export const VOUCHER_BASE_QUERY_KEY = 'voucher';
